<ul>
  <li *ngFor="let text of sanitizedList" class="u-display-inline">
    {{ text }}
  </li>
</ul>
